import React, { useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const utahData = "/img/headerlogo.png";
const bodex = "/img/bodexLogo.png";
const kpi = "/img/KPI-DASH 2.png";
const pdf = "/img/pdf1.png";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TransportationTable3 = ({ data }) => {
  const pdfRef = useRef();

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  const record = data[0];
  const years = Object.keys(record).filter((k) => !isNaN(k));
  const values = years.filter((year) => year <= 2024).map((year) => record[year]);

  const chartData = {
    labels: years.filter((year) => year <= 2024),
    datasets: [
      {
        label: record.sex_label || "Male",
        data: values,
        borderColor: "rgba(54, 162, 235, 1)", // Blue
        backgroundColor: "rgba(54, 162, 235, 0.3)",
        fill: true,
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Male Employment by Year (2018–2024)",
      },
    },
    scales: {
      x: {
        title: { display: true, text: "Year" },
      },
      y: {
        beginAtZero: true,
        title: { display: true, text: "Employment Count" },
      },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;
    const originalWidth = input.style.width;
    input.style.width = "1100px";

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdfDoc = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Header
      pdfDoc.addImage(utahData, "PNG", 60, 10, 32, 16);
      pdfDoc.setFontSize(26);
      pdfDoc.text("UTahData.org", 95, 22);
      pdfDoc.link(50, 15, 60, 10, { url: "https://utahdata.org" });
      pdfDoc.line(10, 35, 200, 35);

      // Chart
      const headerHeight = 38;
      pdfDoc.addImage(imgData, "PNG", 5, headerHeight, imgWidth, imgHeight);

      // Footer
      pdfDoc.line(10, 260, 200, 260);
      const footerY = 265;
      pdfDoc.addImage(utahData, "PNG", 22, footerY, 30, 15);
      pdfDoc.setFontSize(10);
      pdfDoc.text("Built by", 55, footerY + 10);
      pdfDoc.addImage(bodex, "PNG", 68, footerY + 4, 44, 10);
      pdfDoc.text("using", 112, footerY + 10);
      pdfDoc.addImage(kpi, "PNG", 125, footerY, 20, 20);
      pdfDoc.text(" 20250916.v3.198", 148, footerY + 10);

      const currentDate = new Date().toLocaleDateString();
      pdfDoc.text(`Downloaded on: ${currentDate}`, 150, 295);
      pdfDoc.text(`Downloaded from: ${window.location.href}`, 10, 295);

      pdfDoc.save("male-employment-trend.pdf");
      input.style.width = originalWidth;
    });
  };

  return (
    <>
      <div ref={pdfRef} className="content-to-export">
        <div style={{ padding: "20px" }}>
          <h2>Male Employment by Year (2018-2024)</h2>
          <div className="overflow-x-auto">
            <table className="table table-striped bg-white">
              <thead>
                <tr>
                  <th>Year</th>
                  <th>Employment Count</th>
                </tr>
              </thead>
              <tbody>
                {years
                  .filter((year) => year <= 2024)
                  .map((year, idx) => (
                    <tr key={idx}>
                      <td>{year}</td>
                      <td>{values[idx]}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Chart */}
        <div
          style={{
            width: "90%",
            maxWidth: "800px",
            margin: "auto",
            background: "#fff",
          }}
        >
          <Line data={chartData} options={options} />
        </div>
      </div>

      {/* Download button */}
      <br />
      <div className="flex justify-center">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF </span>
          <span>
            <img className="w-[2rem]" src={pdf} alt="pdf-icon" />
          </span>
        </button>
      </div>
    </>
  );
};

export default TransportationTable3;
